import devpConfig from './devp.config'
import preConfig from './pre.config'
import testConfig from './test.config'
import prodConfig from './prod.config'

let config

switch (process.env.RELEASE_ENV) {
  case 'prod':
    config = prodConfig
    break
  case 'test':
    config = testConfig
    break
  case 'devp':
    config = devpConfig
    break
  case 'pre':
    config = preConfig
    break
  default:
    config = devpConfig
}

export default {
  ...config
}
